import { render } from "./Subscribers.vue?vue&type=template&id=43599cd2"
import script from "./Subscribers.vue?vue&type=script&lang=js"
export * from "./Subscribers.vue?vue&type=script&lang=js"

import "./Subscribers.vue?vue&type=style&index=0&id=43599cd2&lang=scss"

import exportComponent from "/var/www/nexgen/apps/admin/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__